import { Button, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import configData from "../config.json";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { getToken } from "../utils/auth"

function Photoes() {
  const params = useParams();
  const navigate = useNavigate();
  const [photoes, setPhotoes] = useState(null);
  const [imagesMessage, setImagesMessage] = useState(null);
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const getCameraImages = () => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/tablet/camera-images/${params.device_id}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data[0].url === "No images found []") {
          notify("No photos found", "error");
        } else {
          notify("Photos updated", "success");
        }
        data.map((item) => {
          if (item.url === "No images found []") {
            setImagesMessage("No image was found");
          } else {
            setImagesMessage("success");
            setPhotoes(data);
          }
        });
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  useEffect(() => {
    document.title = params.serial_number;
    getCameraImages();
  }, []);
  return (
    <div className="container">
      <h1>{params.serial_number}</h1>
      <h4>Status: {imagesMessage && <small>{imagesMessage}</small>}</h4>
      <Button onClick={getCameraImages}>Reload</Button>
      {photoes ? (
        <div>
          {photoes.map((pic, index) => {
            return (
              <div
                key={index}
                style={{
                  position: "relative",
                  height: "100vh",
                }}
              >
                <img src={pic.url} alt="/" style={{ height: "100vh" }} />
                <div
                  style={{
                    position: "absolute",
                    top: "4%",
                    right: "3%",
                    backgroundColor: "#1976d2",
                    color: "white",
                    fontSize: "24px",
                    padding: "5px 10px",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: " 5px",
                    opacity: "0.7",
                  }}
                >
                  <p>{moment(pic.ts).format("HH:mm:ss")}</p>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ textAlign: "center", height: "50vh" }}>
          <br />
          <br />
          <br />
          <br />
          <CircularProgress size={72} />
        </div>
      )}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default Photoes;
